var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.prints","subtitlePath":"admin.printsSubtitle","inputs":_vm.inputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }